import { useEffect } from 'react';

/**
 * @param onLoad **Caution:** Always memoize this function with `useCallback` before using the `useScript` hook.
 */

export const useScript = (
  id: string,
  src: string,
  onLoad?: (this: HTMLScriptElement, event: Event) => void,
) => {
  useEffect(() => {
    if (document.querySelector(`script#${id}`)) {
      throw new Error(`[useScript]: A script element with id ${id} already exists`);
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;

    if (onLoad) {
      script.addEventListener('load', onLoad);
    }

    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [id, src, onLoad]);
};
